if (!customElements.get('color-swatch')) {
	class ColorSwatch extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.optionNodes = this.querySelectorAll('[data-value]')
			this.init()
		}

		disconnectedCallback() {
			this.optionNodes.forEach(button => button.removeEventListener('mouseenter', this.onMouseEnterBound))
		}

		init() {
			const productCard = this.closest('.product-card')
			this.mainImage = productCard ? productCard.querySelector('.product-card__image--main img') : null
			this.onMouseEnterBound = this.onMouseEnter.bind(this)
			this.optionNodes.forEach(button => button.addEventListener('mouseenter', this.onMouseEnterBound))
			this.selected = this.querySelector('a[aria-selected="true"]')
			this.getVariantData()
			this.initOptionSwatches()
		}

		initOptionSwatches() {
			const { colorSwatches = [] } = window.FoxThemeSettings

			this.optionNodes.forEach(optNode => {
				const { optionPosition, value: optionValue, fallbackValue } = optNode.dataset
				const variant = this.variantData.find(v => v[`option${optionPosition}`] && v[`option${optionPosition}`].toLowerCase() === optionValue.toLowerCase())
				const check = colorSwatches.find(c => c.key.toLowerCase() === optionValue.toLowerCase())
				const customColor = check ? check.value : ''

				if (variant) {
					const variantImage = variant.featured_image ? variant.featured_image.src : ''
					optNode.href = `${optNode.href}?variant=${variant.id}`
					if (variantImage) {
						optNode.setAttribute('data-src', getSizedImageUrl(variantImage, '900x'))
						optNode.setAttribute('data-srcset', getSrcset(variantImage))
					}
				}

				optNode.style.removeProperty('background-image')

				if (customColor) {
					optNode.style.setProperty('--bg-color', customColor)
				} else {
					optNode.style.setProperty('--bg-color', fallbackValue)
				}
			})
		}

		onMouseEnter(e) {
			const target = e.currentTarget
			if (this.selected) this.selected.removeAttribute('aria-selected')
			target.setAttribute('aria-selected', true)

			const { src, srcset } = target.dataset
			if (this.mainImage && srcset) {
				this.mainImage.src = src
				this.mainImage.srcset = srcset
			}

			this.selected = target
		}

		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.nextElementSibling.textContent)
		}
	}

	customElements.define('color-swatch', ColorSwatch)
}